import { Text } from '@croquiscom-pvt/zds';
import styled from '@emotion/styled';

interface ItemCardProductProps {
  option_name: string;
  bogo_badge_url?: string;
}

export const ItemCardProduct = ({ option_name, bogo_badge_url }: ItemCardProductProps) => {
  return (
    <ItemHeader>
      {!!bogo_badge_url && <BogoBadge src={bogo_badge_url} alt='1+N 뱃지' />}
      <Text variant='Body_14_Medium' v3Color='gray900' style={{ wordBreak: 'break-all' }}>
        {option_name}
      </Text>
    </ItemHeader>
  );
};

const ItemHeader = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
`;

export const BogoBadge = styled.img`
  width: 21px;
  margin-right: 6px;
`;
